import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CompanyService } from './company.service';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { CompanyListItem } from '../models/company-list.model';
import { CompanyDetail } from '../models/company-detail.model';
import { LoginService } from './login.service';
import { of } from 'rxjs';
import { TariffService } from './tariff.service';


@Injectable({ providedIn: 'root' })
export class ComapnyDashboardResolver implements Resolve<any> {
  constructor(
    private tariffService: TariffService,
    private loginService: LoginService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const id = localStorage.getItem('selectedCompany');
    if (this.loginService.isAdmin() || this.loginService.isSuperadmin()) {
      return this.tariffService.getCompanyTarrif(+id);
    } else {
      return of<any>({});
    }
    
  }
}
